import {
  conversationAnalyticsApi,
  ConversationAnalyticsRangeParams,
  CreateConversationAnalyticsJobParams,
} from "../api/ConversationAnalyticsApi";
import { ConversationAnalyticsConfig } from "../models/Analytics/ConversationAnalyticsModels";

class ConversationAnalyticsManager {
  private static instance: ConversationAnalyticsManager;

  public static get(): ConversationAnalyticsManager {
    if (!this.instance) {
      this.instance = new ConversationAnalyticsManager();
    }
    return this.instance;
  }

  async getConfig() {
    const result = await conversationAnalyticsApi.config.requestHard(null);
    return result.data;
  }

  async updateConfig(config: Partial<ConversationAnalyticsConfig>) {
    const result = await conversationAnalyticsApi.updateConfig.requestHard(
      config
    );
    return result.data;
  }

  async createJob(params: CreateConversationAnalyticsJobParams) {
    const result = await conversationAnalyticsApi.createJob.requestHard(params);
    return result.data;
  }

  async runJob(jobId: string, maxBatches = 1) {
    const result = await conversationAnalyticsApi.runJob(jobId, {
      maxBatches,
    });
    return result.data;
  }

  async getJobs() {
    const result = await conversationAnalyticsApi.jobs.requestHard(null);
    return result.data || [];
  }

  async getOverview(params: ConversationAnalyticsRangeParams) {
    const result = await conversationAnalyticsApi.overview.requestHard(params);
    return result.data;
  }

  async getServices(params: ConversationAnalyticsRangeParams) {
    const result = await conversationAnalyticsApi.services.requestHard(params);
    return result.data;
  }

  async getCustomers(params: ConversationAnalyticsRangeParams) {
    const result = await conversationAnalyticsApi.customers.requestHard(params);
    return result.data;
  }

  async getCustomerTimeline(
    phoneNumber: string,
    params?: { limit?: number; dateFrom?: string; dateTo?: string }
  ) {
    const result = await conversationAnalyticsApi.getCustomerTimeline(
      phoneNumber,
      params
    );
    return result.data || [];
  }
}

export const conversationAnalyticsManager = ConversationAnalyticsManager.get();
